import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RequireObjectDirective} from './require-object.directive';


@NgModule({
  declarations: [RequireObjectDirective],
  exports: [
    RequireObjectDirective
  ],
  imports: [
    CommonModule
  ]
})
export class RequireObjectDirectiveModule { }
